import React from 'react'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { SectionLayoutDialog } from 'shared'

import { useStyles } from './DeletePaymentConfirmDialog.style'

const DeletePaymentConfirmDialog = ({
  open = false,
  onClose = () => {},
  onDelete = () => {},
  pending
}) => {
  const classes = useStyles()

  return (
    <SectionLayoutDialog
      title='Eliminar comprobante de pago'
      open={open}
      onClose={onClose}
      className={classes.dialog}>
      <div className={classes.mainContainer}>
        <div>
          <Typography variant='h6'>
            Estás seguro que quieres eliminar el comprobante, esta acción no se puede deshacer.
          </Typography>
          <br />
          <Typography variant='h6'>
            Una vez eliminado notificaremos al deportista para que vuelva a subirlo, pero te
            recomendamos contactarlo para explicarle cual ha sido el inconveniente con su
            comprobante.
          </Typography>
        </div>
        <div className={classes.buttonContainer}>
          <Button
            variant='outlined'
            color='primary'
            onClick={onClose}
            disabled={pending}
            className={classes.button}>
            Cancelar
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={onDelete}
            className={classes.button}
            disabled={pending}
            endIcon={pending && <CircularProgress color='primary' size={16} />}>
            Eliminar
          </Button>
        </div>
      </div>
    </SectionLayoutDialog>
  )
}

export default DeletePaymentConfirmDialog
